
    import {Component, Vue} from "vue-property-decorator";
    import baseUrl from "../../constants";
    import {fileApi} from "@/api/organization";
    @Component({
        name: "standardMobileImg"
    })
    //
    export default class Home extends Vue {
        title = "上传图片";
        enclosure = "";
        baseUrl = baseUrl
        headers = {Authorization:""};
        accepts = ['PDF', 'JPG', 'PNG']
        guid = "" as any;
        wx = true;
        created() {
            this.guid = this.$route.query.guid;
            this.guid = this.$route.query.guid;
            if(this.$route.query.accepts){
                const accepts = this.$route.query.accepts as string;
                this.accepts = accepts.split(",");
            }
            this.headers.Authorization = this.$store.state.Authorization;
            this.wx = this.isWeiXin();
        }
        //上传监控
        handleAvatarSuccess(res: any) {
            if(res.result === 0){
                this.enclosure = res.data;
            }
        }
        //上传监控
        beforeAvatarUpload(file: any) {
            const lastIndex = file.name.lastIndexOf(".");
            if(lastIndex === -1){
                this.$message.error('此文件格式不存在');
                return false;
            }
            //后缀
            const suffix = file.name.substring(lastIndex + 1 , file.name.length);
            if(this.accepts.indexOf(suffix.toUpperCase()) > -1){
                return true;
            }else{
               this.$message.error('上传只能是 ' + this.accepts.join(" 或 ") +' 格式!');
               return false;
            }
        }
        handleRemove(file:any, fileList:any) {
            fileApi.deleteTemporaryFile({uuid: this.guid})
        }
        //判断是否是微信浏览器的函数
        isWeiXin(){
            //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
            var ua = window.navigator.userAgent.toLowerCase() as any;
            //通过正则表达式匹配ua中是否含有MicroMessenger字符串
            if(ua.match(/MicroMessenger/i) == 'micromessenger'){
                return true;
            }else{
                return false;
            }
        }
    }
